import { Component, OnInit } from '@angular/core';
import { NbWindowRef } from '@nebular/theme';
import { SharedH2hService } from './shared-h2h.service';

@Component({
    selector: 'app-shared-h2h',
    templateUrl: './shared-h2h.component.html',
    styleUrls: ['./shared-h2h.component.scss'],
})
export class SharedH2hComponent implements OnInit {
    registers: any;
    statusCode: number;
    game: any;
    participantes: any;

    constructor(private sharedH2hService: SharedH2hService, protected nbWindowRef: NbWindowRef) {}

    ngOnInit(): void {
        const { id_jogo_detalhe, participantes, ...game }: any = this.nbWindowRef.config.context;

        this.game = game;
        this.participantes = Object.fromEntries(Object.entries(participantes).map(([key, value]) => [key, value[0]]));
        console.log(this.participantes);
        console.log(this.game);
        const player1 = participantes['1'][0];
        const player2 = participantes['2'][0];
        if (!game.sub_jogos) {
            this.sharedH2hService.getH2H(id_jogo_detalhe, player1.id_site, player2.id_site).subscribe((response) => {
                //console.log(response);
                this.registers = response.registers;
            });
        }
    }

    getWinner1(resultado: any) {
        return Number(resultado.resultado_1) > Number(resultado.resultado_2);
    }

    getWinner2(resultado: any) {
        return Number(resultado.resultado_2) > Number(resultado.resultado_1);
    }
}
